import { render, staticRenderFns } from "./PenCanvasMath.vue?vue&type=template&id=7d85ccb8&scoped=true&lang=pug&"
import script from "./PenCanvasMath.vue?vue&type=script&lang=ts&"
export * from "./PenCanvasMath.vue?vue&type=script&lang=ts&"
import style0 from "./PenCanvasMath.vue?vue&type=style&index=0&id=7d85ccb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85ccb8",
  null
  
)

export default component.exports